// extracted by mini-css-extract-plugin
module.exports = {"holdingImage":"holding-image-module--holdingImage--25N7y","icon":"holding-image-module--icon--3Haf2"};